module.exports = __webpack_public_path__ + "static/media/background-testimonial.72ec5960.svg";